import React, { useState } from "react";
import onClickOutside from "react-onclickoutside";


function CustomDropdown(props) {
  const campaignGroups = props.dashboards;
  let currentTab = props.tabLocation === "paidSearch" ? "search" : props.tabLocation === "paidSocial" ? "social" : props.tabLocation === "paidDisplay" ? "display" : props.tabLocation === "paidVideo" ? "video" : undefined

  let upper = currentTab
  if (upper !== undefined) {

    upper = upper[0].toUpperCase() + upper.slice(1)
  }
  const [open, setOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState(
    props.platformName === "all" ? "Search" : props.platformName
  );
  const [currentCampaign, setCurrentCampaign] = useState(props.section !== "Performance" ? campaignGroups[0].name : 0);

  CustomDropdown[`handleClickOutside_` + props.platformName + props.section] = () =>
    setOpen(false);

  const campaignSetter = (campaign, section) => {
    setCurrentCampaign(campaign.name);
    setCurrentSection(section);
    props.setSelectedDashboard(campaign.name)
    props.setSelectedDashboardId(campaign.id)
    setTimeout(() => setOpen(false), 200)
  };

  const goalSetter = (campaign, section) => {
    setCurrentCampaign(campaign.name);
    setCurrentSection(section);
    props.setSelectedDashboardId(campaign.id)
    props.setSelectedDashboard(campaign.name)

    setTimeout(() => setOpen(false), 200)
  };
  const performanceSetter = (campaign, section) => {
    console.log(campaign, section)
    setCurrentCampaign(props.seo ? campaign.id : currentTab);
    setCurrentSection(section);
    props.setSelectedDashboard(campaign.id)
    setTimeout(() => setOpen(false), 200)
  };

  const platform = props.platformName ? props.platformName.charAt(0).toUpperCase() + props.platformName.slice(1) : undefined

  const toggle = () => setOpen(!open);

  return (
    <div className={(props.platformName && props.platformName === "SEO") || props.configure === true ? "campaign-wrapper d-inline-block block-it-mobile pb-0" : "campaign-wrapper subdrop d-inline-block block-it-mobile pb-4"}>
      <div className="campaign-inner d-inline-block">
        <div className="campaign-title" onClick={() => toggle(!open)}>
          {
            props.section === "Performance" ?
              props.seo === undefined ?
                //PPC Performance main input text
                <p className="d-flex f16 nunito-regular primary justify-content-between">
                  {upper}: {(currentTab !== undefined) && (props[`${currentTab}`].filter((el) => el.id === props.selectedDashboard)[0] !== undefined) ? props[`${currentTab}`].length > 0 ? props[`${currentTab}`].filter((el) => el.id === props.selectedDashboard)[0].name : "Overall" : "Overall"}
                  {open ? (
                    <i
                      style={{ pointerEvents: "none" }}
                      className="fas fa-angle-up the-chev"
                    ></i>
                  ) : (
                    <i
                      style={{ pointerEvents: "none" }}
                      className="fas fa-angle-down the-chev"
                    ></i>
                  )}
                </p>
                :
                //SEO Performance main input text
                <p className="d-flex f16 nunito-regular primary justify-content-between">
                  SEO: {props.dashboards.filter((el) => el.id === currentCampaign) && currentCampaign !== 0 ? props.dashboards.filter((el) => el.id === currentCampaign)[0].name : "Overall"}
                  {open ? (
                    <i
                      style={{ pointerEvents: "none" }}
                      className="fas fa-angle-up the-chev"
                    ></i>
                  ) : (
                    <i
                      style={{ pointerEvents: "none" }}
                      className="fas fa-angle-down the-chev"
                    ></i>
                  )}
                </p>
              :
              props.configure === true ?
                props.dashboardId === 0 ? (
                  //configure goals for overall
                  <p className="d-flex f16 nunito-regular primary justify-content-between">
                    {platform === "Seo" ? "SEO" : platform}: Overall
                    {open ? (
                      <i
                        style={{ pointerEvents: "none" }}
                        className="fas fa-angle-up the-chev"
                      ></i>
                    ) : (
                      <i
                        style={{ pointerEvents: "none" }}
                        className="fas fa-angle-down the-chev"
                      ></i>
                    )}
                  </p>
                ) : (

                  //configure goals for remaining
                  <p className="d-flex f16 nunito-regular primary justify-content-between">
                    {platform === "Seo" ? "SEO" : platform}
                    {": "}
                    {props.selectedDashboard}{" "}
                    {open ? (
                      <i
                        style={{ pointerEvents: "none" }}
                        className="fas fa-angle-up the-chev"
                      ></i>
                    ) : (
                      <i
                        style={{ pointerEvents: "none" }}
                        className="fas fa-angle-down the-chev"
                      ></i>
                    )}
                  </p>
                )

                :
                props.selectedDashboardId === 0 ? (
                  //Dashboard and main goals for overall
                  <p className="d-flex f16 nunito-regular primary justify-content-between">
                    {platform === "Seo" ? "SEO" : platform}: Overall
                    {open ? (
                      <i
                        style={{ pointerEvents: "none" }}
                        className="fas fa-angle-up the-chev"
                      ></i>
                    ) : (
                      <i
                        style={{ pointerEvents: "none" }}
                        className="fas fa-angle-down the-chev"
                      ></i>
                    )}
                  </p>
                ) :
                  props.seo === undefined ?
                    (
                      //Dashboard and main goals for remaining
                      <p className="d-flex f16 nunito-regular primary justify-content-between">
                        {currentSection === "Seo" ? "SEO" : currentSection}
                        {": "}
                        {props.selectedDashboard}{" "}
                        {open ? (
                          <i
                            style={{ pointerEvents: "none" }}
                            className="fas fa-angle-up the-chev"
                          ></i>
                        ) : (
                          <i
                            style={{ pointerEvents: "none" }}
                            className="fas fa-angle-down the-chev"
                          ></i>
                        )}
                      </p>
                    )
                    :
                    (
                      //Dashboard and main goals SEO for remaining
                      <p className="d-flex f16 nunito-regular primary justify-content-between">
                        {props.selectedDashboard}{" "}
                        {open ? (
                          <i
                            style={{ pointerEvents: "none" }}
                            className="fas fa-angle-up the-chev"
                          ></i>
                        ) : (
                          <i
                            style={{ pointerEvents: "none" }}
                            className="fas fa-angle-down the-chev"
                          ></i>
                        )}
                      </p>
                    )
          }
        </div>
        <div className={`${open ? "" : "d-none"} campaign-list-container`}>
          <div className="campaign-list">
            <div className="divider"></div>
            {props.section === "Goals" ? (
              //non-clickable display goals/configure goals
              <>
                <div className="py-1">
                  <span className="indent-tier-1"></span>
                  <p className="f16 d-inline nunito-regular bold primary">
                    {platform === "Seo" ? "SEO" : platform} Goals
                  </p>
                </div>
                {campaignGroups.map((dash, idx) => {
                  //name displayed in list goals/configure GOALS  Overall
                  return idx === 0 ? (
                    <div key={idx}>
                      <div
                        className="pb-1 pointer"
                        onClick={() =>
                          goalSetter(dash, platform)

                        }
                      >
                        <span
                          className={`${props.selectedDashboard === dash.name
                            ? "indent-tier-2-active "
                            : "indent-tier-2-inactive "
                            } `}
                        ></span>
                        <span>{platform === "Seo" ? "SEO" : platform}: Overall</span>
                      </div>
                    </div>
                  ) : (
                    //name displayed in list goals/configure Goals remaining
                    <div key={idx}>
                      <div
                        className="pb-1 pointer"
                        onClick={() =>
                          goalSetter(dash, platform)
                        }
                      >
                        <span
                          className={`${props.selectedDashboard === dash.name
                            ? "indent-tier-2-active "
                            : "indent-tier-2-inactive "
                            } `}
                        ></span>
                        <span>
                          {platform === "Seo" ? "SEO" : platform}: {dash.name}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : props.section === "Performance" ?
              props.seo === undefined ?
                (
                  <>
                    <div className="py-1">
                      <span className="indent-tier-1"></span>
                      <p className="f16 d-inline nunito-regular bold primary">
                        {upper} Performance
                      </p>
                    </div>
                    {campaignGroups.map((dash, idx) => {
                      return idx === 0 ? (
                        <div key={idx}>
                          <div
                            className="pb-1 pointer"
                            onClick={() =>
                              performanceSetter(dash, platform)

                            }
                          >
                            <span
                              className={`${props.selectedDashboard === dash.id
                                ? "indent-tier-2-active "
                                : "indent-tier-2-inactive "
                                } `}
                            ></span>
                            <span>{upper}: Overall</span>
                          </div>
                        </div>
                      ) : (
                        <div key={idx}>
                          <div
                            className="pb-1 pointer"
                            onClick={() =>
                              performanceSetter(dash, platform)
                            }
                          >
                            <span
                              className={`${props.selectedDashboard === dash.id
                                ? "indent-tier-2-active "
                                : "indent-tier-2-inactive "
                                } `}
                            ></span>
                            <span>
                              {upper}: {dash.name}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) :
                (
                  <>
                    <div className="py-1">
                      <span className="indent-tier-1"></span>
                      <p className="f16 d-inline nunito-regular bold primary">
                        SEO Performance
                      </p>
                    </div>
                    {campaignGroups.map((dash, idx) => {
                      return idx === 0 ? (
                        <div key={idx}>
                          <div
                            className="pb-1 pointer"
                            onClick={() =>
                              performanceSetter(dash, platform)
                            }
                          >
                            <span
                              className={`${currentCampaign === dash.id
                                ? "indent-tier-2-active "
                                : "indent-tier-2-inactive "
                                } `}
                            ></span>
                            <span>SEO: Overall</span>
                          </div>
                        </div>
                      ) : (
                        <div key={idx}>
                          <div
                            className="pb-1 pointer"
                            onClick={() =>
                              performanceSetter(dash, platform)
                            }
                          >
                            <span
                              className={`${currentCampaign === dash.id
                                ? "indent-tier-2-active "
                                : "indent-tier-2-inactive "
                                } `}
                            ></span>
                            <span>
                              SEO: {dash.name}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) :
              (
                <>
                  <div className="py-1">
                    <span className="indent-tier-1"></span>
                    <p className="f16 d-inline nunito-regular bold primary">
                      {props.platformName} Overall
                    </p>
                  </div>
                  {campaignGroups.map((dash, idx) => {
                    return idx === 0 ? (
                      <div key={idx}>
                        <div
                          className="pb-1 pointer"
                          onClick={() =>
                            campaignSetter(dash, props.platformName)

                          }
                        >
                          <span
                            className={`${currentCampaign === dash.name &&
                              props.platformName === currentSection
                              ? "indent-tier-2-active "
                              : "indent-tier-2-inactive "
                              } `}
                          ></span>
                          <span>{props.platformName}: Overall</span>
                        </div>
                      </div>
                    ) : (
                      <div key={idx}>
                        <div
                          className="pb-1 pointer"
                          onClick={() =>
                            campaignSetter(dash, props.platformName)
                          }
                        >
                          <span
                            className={`${currentCampaign === dash.name &&
                              props.platformName === currentSection
                              ? "indent-tier-2-active "
                              : "indent-tier-2-inactive "
                              } `}
                          ></span>
                          <span>
                            {props.platformName}: {dash.name}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

const clickOutsideConfig = {
  handleClickOutside: ({ props }) =>
    CustomDropdown[`handleClickOutside_` + props.platformName + props.section],
};

export default onClickOutside(CustomDropdown, clickOutsideConfig);
